import { render, staticRenderFns } from "./NumberOrder.vue?vue&type=template&id=64ced00e&scoped=true"
import script from "./NumberOrder.vue?vue&type=script&lang=js"
export * from "./NumberOrder.vue?vue&type=script&lang=js"
import style0 from "./NumberOrder.vue?vue&type=style&index=0&id=64ced00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ced00e",
  null
  
)

export default component.exports